import autosize from 'autosize';
import { Arrive } from 'arrive';

// IMPORT - UTILS
import { isJavascriptEnabled } from './utils/isJavascriptEnabled';
import { getFocusable } from './utils/getFocusable';
import { nextFocusable } from './utils/nextFocusable';
import { isPrintableChar } from './utils/isPrintableChar';
import { isInputable } from './utils/isInputable';
import { isSet } from './utils/isSet';

//IMPORT - FUNCTIONS
import { initEmblaCarousels } from "./functions/emblaCarouselInit";
import { loadResourceFile } from "./functions/loadResourceFile";

//IMPORT - CLASSES
import { Layer } from "./classes/Layer";
import { Accordion } from "./classes/Accordion";
import { Dropdown } from "./classes/Dropdown";
import { TabList } from "./classes/TabList";
import { StickyHeader } from "./classes/StickyHeader";
import { Masonry } from "./classes/Masonry";
import { QuantityButton } from "./classes/QuantityButton";
import { TimelineVideo } from "./classes/TimelineVideo";
import { YoutubeEmbed } from "./classes/YoutubeEmbed";
import { MediaContent } from "./classes/MediaContent";
import { PageNavigation } from "./classes/PageNavigation";
import { Video } from "./classes/Video";
import { Product } from "./classes/Product";
import { Filter } from "./classes/Filter";

isJavascriptEnabled();


/**
 * SETUP GLOBAL VARS
 */
    const focusableElements = [
        'a[href]:not([disabled]):not([hidden]):not([aria-hidden])',
        'area[href]:not([disabled]):not([hidden]):not([aria-hidden])',
        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
        'select:not([disabled]):not([aria-hidden])',
        'textarea:not([disabled]):not([aria-hidden])',
        'button:not([disabled]):not([aria-hidden])',
        'iframe:not([disabled]):not([hidden]):not([aria-hidden])',
        'object:not([disabled]):not([hidden]):not([aria-hidden])',
        'embed:not([disabled]):not([hidden]):not([aria-hidden])',
        '[contenteditable]:not([disabled]):not([hidden]):not([aria-hidden])',
        '[tabindex]'
    ];
    window.focusableElements = focusableElements;

    const store = {
        activeLayers: [],
        activeLayer: ''
    };
    window.store = store;

    window.filesadded = "";

/**
 * MASTHEAD
 */
    const masthead = document.querySelector("#masthead .site-header__main");
    if(isSet(masthead)){
        new StickyHeader(masthead);
    }


/**
 * CAROUSELS
 */
    initEmblaCarousels();


/**
 * ACCORDIONS
 */
    const generalAccordions = document.querySelectorAll(".accordion--js");
    generalAccordions.forEach(function (accordionElm) {
        new Accordion(
            accordionElm,
            {
                collapsible:true,
                type: 'multiple'
            }
        );
    });

    //Support & watch for woocommerce cart fragement updates
    document.arrive(
        ".accordion--js", 
        function(newAccordionElm) {
            new Accordion(
                newAccordionElm,
                {
                    collapsible:true,
                    type: 'multiple'
                }
            );
        }
    );

    const productAccordions = document.querySelectorAll(".woocommerce-accordion-group--js");
    productAccordions.forEach(function (accordionElm) {
        new Accordion(
            accordionElm,
            {
                collapsible:true
            }
        );
    });

    const testimonialAccordions = document.querySelectorAll(".accordion--testimonial--js");
    testimonialAccordions.forEach(function (accordionElm) {
        new Accordion(
            accordionElm,
            {
                onAfterOpen: (object, event, item) => {
                    const span = item.trigger.querySelector('span');
                    if(isSet(span)) span.textContent = herschel_theme_locale_strings.collapse;

                    const icon = item.trigger.querySelector('i');
                    if(isSet(icon)) icon.classList.remove('herschel-icon--chevron-down');
                    if(isSet(icon)) icon.classList.add('herschel-icon--chevron-up');
                },
                onAfterClose: (object, event, item) => {
                    const span = item.trigger.querySelector('span');
                    if(isSet(span)) span.textContent = herschel_theme_locale_strings.readthefulltestimonial;

                    const icon = item.trigger.querySelector('i');
                    if(isSet(span)) icon.classList.remove('herschel-icon--chevron-up');
                    if(isSet(span)) icon.classList.add('herschel-icon--chevron-down');
                },
                collapsible:true,
                type: 'multiple'
            }
        );
    });


/**
 * DROPDOWNS
 */
    const dropdowns = document.querySelectorAll(".dropdown--js");
    dropdowns.forEach(function (dropdownElm) {
        let options = {}

        if(dropdownElm.id === 'active-search'){
            options['openOnTriggerClick'] = true;
            options['openOnTriggerKeyup'] = true;
            options['setFocusOnOpen'] = false;
            options['closeOnTriggerClick'] = false;
        }

        let dropdown = new Dropdown(
            dropdownElm,
            options
        );

        jQuery(document.body).on( 'added_to_cart', function(obj, fragments, hash){
            if(dropdownElm.id === 'dropdown--basket'){
                dropdown.openDropdown();
            }
        });
    });

    const subMenus = document.querySelectorAll(".sub-menu--js");
    subMenus.forEach(function (subMenuElm) {
        /** @type {DropdownDefault} */
        let subMenu = new Dropdown(
            subMenuElm,
            {
                openOnTriggerClick: false,
                openOnTriggerHover: true,
                setFocusOnOpen: false,
                focusOnItemMouseOver: true
            }
        );
    });

    const searchToggle = document.querySelector('.search-menu-toggle--js');
    const afterHeader = document.querySelector('.site-header__after');

    if(isSet(searchToggle) && isSet(afterHeader)){
        searchToggle.addEventListener('click', function(){
            afterHeader.classList.toggle('is-open');
            searchToggle.classList.toggle('is-open');
        })
    }

    function handleSearchSuggestionClick(searchSuggestionBtnElm){
        if(!isSet(searchSuggestionBtnElm)) return;

        searchSuggestionBtnElm.addEventListener('click', function(e){
            const searchInputElm = document.querySelector('#site-search--desktop');
            if(!isSet(searchInputElm)) return;

            const searchSuggestionBtnValue = e.currentTarget.querySelector('span').textContent;

            searchInputElm.value = searchSuggestionBtnValue;

            searchInputElm.focus();

            searchInputElm.dispatchEvent(new Event("input", { bubbles: true }));

            const keyupEvent = new KeyboardEvent("keyup", {
                key: "ArrowDown",   // or "Enter"
                code: "ArrowDown",
                bubbles: true,
                cancelable: true
            });
            searchInputElm.dispatchEvent(keyupEvent);
        })
    }

    const searchSuggestionBtnElm = document.querySelector('.btn--search-suggestion--js');
    if(isSet(searchSuggestionBtnElm)){
        handleSearchSuggestionClick(searchSuggestionBtnElm);
    }

    document.arrive(
        ".btn--search-suggestion--js", 
        function(newSearchSuggestionButtonElm) {
            handleSearchSuggestionClick(
                newSearchSuggestionButtonElm
            );
        }
    );

/**
 * LAYERS
 */
    const layers = document.querySelectorAll(".layer--js");
    layers.forEach( function (layerElm) {
        let layer = new Layer(
            layerElm,
            {
                awaitCloseAnimation: true,
                awaitOpenAnimation: true,
            }
        );

        if(layer.id === 'layer--calculator'){
            layerElm.addEventListener('layerbeforeopen', function(){
                loadResourceFile( herschel_theme_locale_strings.themedir + "/wattage-calculator/assets/js/app.min.js", "js");
                loadResourceFile( herschel_theme_locale_strings.themedir + "/wattage-calculator/assets/css/bootstrap-custom.css", "css");
                setTimeout(function() { autosize(document.querySelector('#XLEW_1_16_1')); }, 200);
            });
        }


        if(layer.id === 'layer--quote'){
            layerElm.addEventListener('layerbeforeopen', function(){
                loadResourceFile( herschel_theme_locale_strings.themedir + "/wattage-calculator/online-calc-newdesign/assets/js/app.min.js", "js");
                loadResourceFile( herschel_theme_locale_strings.themedir + "/wattage-calculator/assets/css/bootstrap-custom.css", "css");
            });
        }
    });


const orderCommentsElm = document.querySelector('#order_comments');
if(isSet(orderCommentsElm)){
    autosize(orderCommentsElm);
}


/**
 * QUANTITY INPUTS
 */
    const quantityButtons = document.querySelectorAll(".btn--quantity--js");
    quantityButtons.forEach(function (quantityButton) {
        new QuantityButton(
            quantityButton
        );
    });

    //Support & watch for woocommerce cart fragement updates
    document.arrive(
        ".btn--quantity--js", 
        function(newQuantityButtonElm) {
            new QuantityButton(
                newQuantityButtonElm
            );
        }
    );

/**
 * MASONRY GRIDS
 */
    const masonryGrids = document.querySelectorAll(".masonry-grid--js");
    masonryGrids.forEach(function (masonryGridElm) {
        const masonryGrid = new Masonry(
            masonryGridElm
        );

        const newMasonryItems = [];

        document.addEventListener('htmx:afterSettle', function(e){
            if(e.detail.elt.classList.contains('load-more-trigger')){
                masonryGrid.append(newMasonryItems);
            }
            
            const post_type = e.detail.requestConfig.formData.get('post_type');

            if(!isSet(post_type) || post_type !== 'testimonials') return;

            if(!isSet(e.detail.elt) || !e.detail.elt.hasAttribute('masonry-item')) return;

            const newMasonryItem = e.detail.elt;
            
            newMasonryItems.push(newMasonryItem);
        });
    });

/**
 * TABLIST
 */
    const tablistElms = document.querySelectorAll('.herschel-tablist--js');
    tablistElms.forEach(function (tablistElm) {
        const tablist = new TabList(
            tablistElm,
            {}
        );
    });


/**
 * TIMELINE VIDEOS
 */
    const timelineVideoElms = document.querySelectorAll(".timeline-video--js");
    timelineVideoElms.forEach(function (timelineVideoElm) {
        const timelineVideo = new TimelineVideo(
            timelineVideoElm
        );
    });


/**
 * MEDIA CONTENT BLOCKS
 */
    const mediaContentElms = document.querySelectorAll(".media-content--js");
    mediaContentElms.forEach(function (mediaContentElm) {
        const mediaContent = new MediaContent(
            mediaContentElm
        );
    });


/**
 * INNER PAGE NAVIGATIONS
 */
    const pageNavigationElms = document.querySelectorAll(".page-content-navigation--js");
    pageNavigationElms.forEach(function (pageNavigationElm) {
        const pageNavigation = new PageNavigation(
            pageNavigationElm
        );
    });

/**
 * VIDEO
 */
    const videoElms = document.querySelectorAll(".herschel-video--js");
    videoElms.forEach(function (videoElm) {
        const video = new Video(
            videoElm
        );
    });

/**
 * YOUTUBE EMBED
 */
const youtubeEmbedElms = document.querySelectorAll(".embed--yt--js");
youtubeEmbedElms.forEach(function (youtubeEmbedElm) {
    const youtubeEmbed = new YoutubeEmbed(
        youtubeEmbedElm
    );

    function onYouTubeIframeAPIReady(){
        youtubeEmbed.onYouTubeIframeAPIReady();
        console.log('sdfsdf');
    };
});


/**
 * MEDIA CONTENT BLOCKS
 */
    const productContainerElms = document.querySelectorAll(".product--js");
    productContainerElms.forEach(function (productContainerElm) {
        const product = new Product(
            productContainerElm
        );
    });


/**
 * FILTERS
 */
    const filterElms = document.querySelectorAll(".filter--js");
    filterElms.forEach(function (filterElm) {
        const filter = new Filter(
            filterElm
        );
    });

    const filtersContainerElms = document.querySelectorAll('.herschel-filters--js');
    filtersContainerElms.forEach(function (filtersContainerElm) {
        const layerElm = filtersContainerElm.querySelector('.layer--js');
        const layerDialogElm = layerElm.querySelector('.layer__container');

        function adjustLayerAttributes(){
            const width = document.body.clientWidth;
                
            if(width < 767){
                layerElm.setAttribute('aria-hidden', 'true');
                layerElm.setAttribute('role', 'dialog');

                layerDialogElm.setAttribute('role', 'dialog');
                layerDialogElm.setAttribute('aria-modal', 'true');
            } else{
                layerElm.setAttribute('aria-hidden', 'false');
                layerElm.removeAttribute('role');

                layerDialogElm.removeAttribute('role');
                layerDialogElm.removeAttribute('aria-modal');
            }
        }

        window.addEventListener(
            'resize', 
            adjustLayerAttributes
        );

        window.addEventListener(
            'load', 
            adjustLayerAttributes
        );

        const filterElms = filtersContainerElm.querySelectorAll('.post-filter');
        const filterMobileToggleLabel = filtersContainerElm.querySelector('[layer-open] .filters-active-count');

        let activeFilters = [];

        filterElms.forEach((filterElm) => {
            filterElm.addEventListener('change', (e) => {
                const selected = Array.from(
                    filterElm.options
                ).filter(
                    function (option) {
                        return option.selected;
                    }
                ).map(
                    function (option) {
                        return option.value;
                    }
                );

                if(selected.length > 0){
                    if(activeFilters.indexOf(filterElm.name) == -1) activeFilters.push(filterElm.name)
                } else{
                    if(activeFilters.indexOf(filterElm.name) !== -1) activeFilters.splice(activeFilters.indexOf(filterElm.name), 1)
                }

                if(!isSet(filterMobileToggleLabel)) return;

                if(activeFilters.length > 0){
                    filterMobileToggleLabel.textContent = activeFilters.length + ' ' + herschel_theme_locale_strings.active
                } else{
                    filterMobileToggleLabel.textContent = '';
                }
            });
        })
    });

/**
 * ANIMATION OBSERVER
 */
    function animationObserver(){
        const observableElms = Array.from(document.querySelectorAll(".has-animation.is-animation-target, .has-animation .is-animation-target"));

        if ("IntersectionObserver" in window) {
            let animationObserver = new IntersectionObserver(
                function(entries, observer) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            let element = entry.target;
                            element.classList.add('has-animation-triggered');
                            animationObserver.unobserve(element);
                        }
                    });
                },
                {
                    threshold: 0.15,
                }
            );

            observableElms.forEach(function(target) {
                animationObserver.observe(target);
            });
        } else{
            observableElms.forEach(function(element) {
                element.classList.add('has-animation-triggered');
            });
        }
    }
    animationObserver();

    document.arrive(
        ".is-animation-target", 
        function(target) {
            if ("IntersectionObserver" in window) {
                let animationObserver = new IntersectionObserver(
                    function(entries, observer) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                let element = entry.target;
                                element.classList.add('has-animation-triggered');
                                animationObserver.unobserve(element);
                            }
                        });
                    },
                    {
                        threshold: 0.15,
                    }
                );

                animationObserver.observe(target);
            } else{
                target.classList.add('has-animation-triggered');
            }

        }
    );

/**
 * JQUERY 
 * @deprecated - for old product layout
 */
    jQuery(document).ready(function($){
        $( document ).on( 'change', '.variations-radio--js input', function() {
            $( '.variations-radio--js input:checked' ).each( function( index, element ) {
                const radio = $(element)
                const radioName = radio.attr( 'name' )
                const radioValue  = radio.attr( 'value' )
                $( 'select[name="' + radioName + '"]' ).val( radioValue ).trigger( 'change' );
            })
        })
    });



/**
 *  -------- OLD & TO BE CONVERTED --------
 */ 
    const room_step_container = document.querySelector(".step-2-container");
    if (typeof(room_step_container) != 'undefined' && room_step_container != null) {
        let room_containers = room_step_container.querySelectorAll(".calc-row");
        console.log(room_containers);
        let i = 1;
        let add_room = document.getElementById("add-room");
        let remove_room = document.getElementById("remove-room");

        document.addEventListener("DOMContentLoaded", function() {
            var roomList = JSON.parse(localStorage.getItem("roomlist") || "[]");
            if (roomList == null || undefined) {
                localStorage.setItem('roomlist', '[]');
            }

            if (roomList.length === 0) {
                remove_room.classList.add('hidden');
            }else if(roomList.length === 6){
                add_room.classList.add('hidden');
            }else{
                //Do Nothing, LeBron...
            }

            for (let roomIndex of roomList) {
                let setRoom = document.querySelector('.room-row[data_index="' + roomIndex + '"]');
                setRoom.classList.remove('hidden');
                setRoom.classList.add('active');
            }
        });
        
        
        add_room.onclick = function(e) {
            let firstHidden = room_step_container.getElementsByClassName('hidden')[0];
            if(typeof(firstHidden) != 'undefined'){

                let latestRoomList = JSON.parse(localStorage.getItem("roomlist") || "[]");

                firstHidden.classList.remove('hidden');
                firstHidden.classList.add('active');
                let room_index = firstHidden.getAttribute('data_index');

                latestRoomList.push(room_index);
                localStorage.setItem('roomlist', JSON.stringify(latestRoomList));


                if (latestRoomList.length === 6) {
                    add_room.classList.add('hidden');
                }

                if (latestRoomList.length >= 1) {
                    remove_room.classList.remove('hidden');
                }

            } else {
                console.log('Max Rooms Reached');
            }
        }
        remove_room.onclick = function(e) {
            let allActive = room_step_container.getElementsByClassName('active');
            let lastActive = allActive[allActive.length -1];
            

            if(typeof(lastActive) != 'undefined'){

                let latestRoomList = JSON.parse(localStorage.getItem("roomlist") || "[]");

                let dirtyInputs = lastActive.querySelectorAll('input');
                for (let cleanInput of dirtyInputs) {
                    cleanInput.value = "";
                    cleanInput.dispatchEvent(new Event('change'));
                }

                lastActive.classList.add('hidden');
                lastActive.classList.remove('active');
                
                latestRoomList.splice(-1, 1);

                localStorage.setItem('roomlist', JSON.stringify(latestRoomList));

                if (latestRoomList.length === 0) {
                    remove_room.classList.add('hidden');
                }

                if (latestRoomList.length <= 5) {
                    add_room.classList.remove('hidden');
                }

            } else {
                console.log('Cant remove last room');
            }
        }
        for (let room_container of room_containers) {
            let data_index = document.createAttribute("data_index");
            let inc = i++;
            data_index.value = inc;
            room_container.setAttributeNode(data_index);
        }

    }